/**
 * Survey visibility by scope (Beta-1 plan P3-03, Tim C0820 "site manager sees active surveys in
 * departments beneath them"): a survey is visible when its target scope is inside the viewer's
 * scope. Pure module.
 *
 *   viewerLock  { siteId?, deptId?, nwtId? } — the persona's lock (null / {} = whole organization)
 *   target      survey.targetScope { type: 'organization'|'site'|'department'|'team', id }
 */

/** Resolve a survey target to { siteId, deptId, nwtId } using the org structure. */
export function targetUnits(target, org) {
  if (!target || !target.type || target.type === 'organization') return { siteId: null, deptId: null, nwtId: null };
  const departments = org?.departments || [];
  const teams = org?.teams || [];
  if (target.type === 'site') return { siteId: target.id, deptId: null, nwtId: null };
  if (target.type === 'department') {
    const d = departments.find((x) => x.id === target.id);
    return { siteId: d?.siteId || null, deptId: target.id, nwtId: null };
  }
  if (target.type === 'team') {
    const t = teams.find((x) => x.id === target.id);
    const d = t ? departments.find((x) => x.id === t.departmentId) : null;
    return { siteId: d?.siteId || null, deptId: t?.departmentId || null, nwtId: target.id };
  }
  return { siteId: null, deptId: null, nwtId: null };
}

/** Is the survey's target inside the viewer's lock? An org-wide survey is visible to everyone. */
export function surveyVisibleTo(survey, viewerLock, org) {
  const lock = viewerLock || {};
  if (!lock.siteId && !lock.deptId && !lock.nwtId) return true;
  const target = survey?.targetScope;
  if (!target || !target.type || target.type === 'organization') return true;
  const u = targetUnits(target, org);
  if (lock.nwtId) return u.nwtId === lock.nwtId;
  if (lock.deptId) return u.deptId === lock.deptId;
  if (lock.siteId) return u.siteId === lock.siteId;
  return true;
}

/** "Operations dept" / "Houston Plant" / "Shift Crew A" / "All sites" for the row label. */
export function surveyScopeLabel(survey, org) {
  const target = survey?.targetScope;
  if (!target || !target.type || target.type === 'organization') return 'All sites';
  if (target.type === 'site') return (org?.sites || []).find((s) => s.id === target.id)?.name || 'Site';
  if (target.type === 'department') {
    const name = (org?.departments || []).find((d) => d.id === target.id)?.name;
    return name ? `${name} dept` : 'Department';
  }
  if (target.type === 'team') return (org?.teams || []).find((t) => t.id === target.id)?.name || 'NWT';
  return 'All sites';
}
